module.exports = __webpack_public_path__ + "static/media/coinexDark.4211b73f.png";